import { render, staticRenderFns } from "./StudentSummit.vue?vue&type=template&id=2d71a52a&scoped=true&"
import script from "./StudentSummit.vue?vue&type=script&lang=js&"
export * from "./StudentSummit.vue?vue&type=script&lang=js&"
import style0 from "./StudentSummit.vue?vue&type=style&index=0&id=2d71a52a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71a52a",
  null
  
)

export default component.exports